import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./context/LanguageContext";
import { AuthProvider } from "./context/AuthContext";
import Home from "./pages/Home";
import Staff from "./pages/Staff";
import StaffDetail from "./pages/StaffDetail";
import Centres from "./pages/Centres";
import CentreDetail from "./pages/CentreDetail";
import Collaborer from "./pages/Collaborer";
import Blog from "./pages/Blog";
import BlogDetail from "./pages/BlogDetail";
import Privacy from "./pages/Privacy";
import NotFound from "./pages/NotFound";
import Legal from "./pages/Legal";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminLayout from "./pages/admin/AdminLayout";
import AdminDashboard from "./pages/admin/AdminDashboard";
import BlogAdmin from "./pages/admin/BlogAdmin";
import StaffAdmin from "./pages/admin/StaffAdmin";
import ServicesAdmin from "./pages/admin/ServicesAdmin";

function App() {
  return (
    <AuthProvider>
      <LanguageProvider>
        <div className="App">
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/equipe" element={<Staff />} />
              <Route path="/equipe/:slug" element={<StaffDetail />} />
              <Route path="/centres" element={<Centres />} />
              <Route path="/centres/:slug" element={<CentreDetail />} />
              <Route path="/collaborez" element={<Collaborer />} />
              <Route path="/actualites" element={<Blog />} />
              <Route path="/actualites/:slug" element={<BlogDetail />} />
              <Route path="/confidentialite" element={<Privacy />} />
              <Route path="/mentions-legales" element={<Legal />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<AdminDashboard />} />
                <Route path="blog" element={<BlogAdmin />} />
                <Route path="staff" element={<StaffAdmin />} />
                <Route path="services" element={<ServicesAdmin />} />
              </Route>
              <Route path="*" element={<NotFound />} />
            </Routes>
          </BrowserRouter>
        </div>
      </LanguageProvider>
    </AuthProvider>
  );
}

export default App;
